<template>
    <div>
        <b-row class="mt-2">
            <b-col md="6">
                <b-form-group>
                    <b-form-input v-model="consultarterapia" placeholder="Buscar por nombre o código de la terapia."
                        type="text" class="d-inline-block" />
                </b-form-group>
            </b-col>
            <b-col md="3" class="d-flex align-items-center">
                <b-form-group class="w-100 mb-0">
                    <v-select
                      v-model="filtroTipoTerapia"
                      :options="tiposTerapia"
                      :reduce="o => o.value"
                      label="text"
                      placeholder="Filtrar por tipo"
                      class="d-inline-block w-100"
                    />
                </b-form-group>
            </b-col>
            <b-col
              md="3"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              v-if="isXima"
            >
                <b-form-group class="w-100 mb-0">
                    <v-select
                      id="establecimiento"
                      v-model="consultarestablecimiento"
                      :options="establecimientosList"
                      placeholder="Seleccionar establecimiento."
                      :reduce="option => option.value"
                      label="text"
                      class="d-inline-block w-100"
                    />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                <b-button variant="primary" class="mr-1" @click="buscarTerapia">
                    <font-awesome-icon icon="magnifying-glass" style="color: white;" /> <span style="color: white;">
                        buscar</span>
                </b-button>
                <b-button variant="success" @click="$bvModal.show('modal-crear-terapia')">
                    <span style="color: white; font-weight: 700;">+</span>
                    <span style="color: white;"> Crear</span>
                </b-button>
            </b-col>
        </b-row>
        <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
            <b-card class="principal">
                <b-col cols="12" class="pr-0 pl-0 mt-2">
                    <b-table v-if="itemsFiltrados.length > 0" bordered striped responsive :total-rows="totalRows"
                        :current-page="currentPage" :items="itemsFiltrados" :fields="fields" :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
                        :filter-included-fields="filterOn" @filtered="onFiltered">
                      
                        <template #cell(estadoJson)="data">
                            <div class="row">
                                <label class="col-6">Iess: <span :class="data.item.estadoJson.iess ? 'text-success' : 'text-danger'">{{ data.item.estadoJson.iess ? 'Activo' : 'Inactivo' }}</span></label>
                                <label class="col-6">Issfa: <span :class="data.item.estadoJson.issfa ? 'text-success' : 'text-danger'">{{ data.item.estadoJson.issfa ? 'Activo' : 'Inactivo' }}</span></label>
                                <label class="col-6">Isspol: <span :class="data.item.estadoJson.isspol ? 'text-success' : 'text-danger'">{{ data.item.estadoJson.isspol ? 'Activo' : 'Inactivo' }}</span></label>
                                <label class="col-6">Particular: <span :class="data.item.estadoJson.particular ? 'text-success' : 'text-danger'">{{ data.item.estadoJson.particular ? 'Activo' : 'Inactivo' }}</span></label>
                            </div>
                        </template>
                        <template #cell(establecimientos)="data">
                          <div class="d-flex flex-column">
                            <span v-for="est in (data.item.establecimientos || [])" :key="est.id">
                              {{ est.nombre }}:
                              <span :class="est.activo ? 'text-success' : 'text-danger'">
                                {{ est.activo ? 'Activo' : 'Inactivo' }}
                              </span>
                            </span>
                          </div>
                        </template>
                        <template #cell(nombre)="data">
                          <div :id="'tooltip-nombre-' + data.index" v-b-tooltip.hover :title="data.item.nombre">
                            ({{data.item.codigo}}) {{ truncateTexto(data.item.nombre, 50) }}
                          </div>
                        </template>
                        <template #cell(acciones)="data">
                            <div class="d-flex justify-content-end">
                                <b-button variant="info" size="sm" class="mr-1" @click="viewItem(data.item.tokenTerapia)">
                                    <font-awesome-icon icon="magnifying-glass" style="color: white;" />
                                </b-button>
                                <b-button variant="primary" size="sm" @click="editItem(data.item.tokenTerapia)">
                                    <font-awesome-icon icon="user-pen" style="color: white;" />
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                    <div v-else class="text-center">
                        <p>No se encontraron registros</p>
                    </div>
                </b-col>

                <b-col cols="12" class="mb-2">
                    <b-pagination v-if="itemsFiltrados.length > 0" v-model="currentPageModificado" :total-rows="totalRows"
                        :per-page="perPage" :small="true" first-number last-number class="mb-0" align="center"
                        prev-class="prev-item" next-class="next-item" @change="cambiarPagina">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </b-col>
            </b-card>
        </b-overlay>
        <b-modal id="modal-editar-terapia" size="lg" hide-footer>
            <CrearEditarTerapia :tokenterapia="tokenSeleccionado" />

        </b-modal>
        <b-modal id="modal-crear-terapia" size="lg" hide-footer>
            <CrearEditarTerapia />
        </b-modal>
        <b-modal id="modal-ver-terapia" size="lg" hide-footer title="Ver Item Terapia">
            <Verterapia v-if="tokenSeleccionado" :key="tokenSeleccionado" :token="tokenSeleccionado" />
        </b-modal>
        <!-- <b-modal v-model="modalShow" @show="cargarComponente" title="Detalles de la Terapia">
            <component :is="componenteDinamico" v-if="componenteDinamico" :token="tokenSeleccionado"></component>

        </b-modal> -->
    </div>
</template>

<script>
import {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BOverlay,
    BFormGroup,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BModal,
} from 'bootstrap-vue'
import actions from '@/assets/utils/utils'
import BCardCode from '@core/components/b-card-code'
import vSelect from 'vue-select'
import { comprobarPermisos, getEstablecimientoLS } from "@/shared/helpers";
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import CrearEditarTerapia from './CrearEditarTerapia.vue';
import Verterapia from './Verterapia.vue';

export default {
    components: {
        BCard,
        BCardCode,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BButton,
        BTable,
        BMedia,
        BAvatar,
        BOverlay,
        BLink,
        BBadge,
        BDropdown,
        BDropdownItem,
        BPagination,
        BTooltip,
        vSelect,
        BModal,
        CrearEditarTerapia,
        Verterapia,
    },
    computed: {
        itemsFiltrados() {
            if (!this.appliedFiltroTipo) return this.items;
            return this.items.filter(it => String(it.tipoTerapiaId || '') === String(this.appliedFiltroTipo));
        },
        isXima() {
            return this.currentEstablecimiento && this.currentEstablecimiento.uniCodigo === '36451';
        },
    },
    data() {

        return {
            idEstablecimiento: null,
            currentEstablecimiento: getEstablecimientoLS && getEstablecimientoLS(),
            tokenSeleccionado: null,
            modalShow: false,
            componenteDinamico: null,
            pagina_actual: 1,
            currentPage: 1,
            currentPageModificado: 1,
            mostrarLoader: false,
            login_user: '',
            consultarterapia: null,
            consultarestablecimiento: '',
            establecimientos: [],
            establecimientosList: [],
            establecimiento: '',
            perPage: 15,
            pageOptions: [3, 5, 10],
            totalRows: 3,
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            infoModal: {
                id: 'info-modal',
                title: '',
                content: '',
            },
            fields: [
                { key: 'estadoJson', label: 'Estado', sortable: true, thClass: 'text-center' },
                { key: 'establecimientos', label: 'Establecimiento', sortable: true, thClass: 'text-center' },
                { key: 'nombre', label: 'Nombre', sortable: true, thClass: 'text-center' },
                { key: 'tipoTerapia', label: 'Tipo', sortable: true, thClass: 'text-center' },
                { key: 'usuario', label: 'Usuario', sortable: true, thClass: 'text-center' },
                { key: 'acciones', label: 'acciones', sortable: true, thClass: 'text-center', tdClass: 'text-right' },

            ],
            listaAcciones: [],
            token_usuario: '',
            configdateTimePicker: {
                enableTime: false,
                dateFormat: 'd/m/Y',
            },
            items: [],
            tiposTerapia: [],
            filtroTipoTerapia: null,
            appliedFiltroTipo: null,
            descripcion: '',
            idsTerapias: [],
            estado: null,
            estados: [
                { value: '1', text: 'Activo' },
                { value: '0', text: 'Inactivo' }
            ],
        }
    },
    created() {
        comprobarPermisos(this.$route);
        const user = JSON.parse(localStorage.getItem('detalleusuario'))
        this.idEstablecimiento = user && user.establecimiento ? user.establecimiento.id : ""
        this.currentEstablecimiento = user ? user.establecimiento : null
        this.fetchConsultarTerapia()
        this.setToken();
        this.fetchEstablecimientos();
        this.fetchTipoTerapias();
    },
    mounted() {
        actions.setearTitulo('Terapias')
        this.fetchConsultarTerapia()

    },

    methods: {
        async cambiarEstadoIds() {
            if (!this.estado) {
                this.$swal.fire({
                    icon: "info",
                    text: "Por favor, seleccione un estado."
                })
            } else if (this.estado && this.idsTerapias.length === 0) {
                this.$swal.fire({
                    icon: "info",
                    text: "Por favor, seleccione al menos una terapia."
                })
            } else {
                const query = ` mutation CambiarEstadoTerapias($terapiaDatos: TerapiaEstadoInput!) {
                                cambiarEstadoTerapia(terapiaDatos: $terapiaDatos) {
                                    status
                                    message
                                }
                                } `


                let variables = {
                    terapiaDatos: {
                        id: this.idsTerapias,
                        estado: this.estado,
                    }
                }

                try {

                    const response = await axios.post(rutas.axios + 'api', { query, variables });

                    if (response.data.data.cambiarEstadoTerapia.status === 'SUCCESS') {
                        await this.$swal.fire({
                            title: 'Exito',
                            icon: 'success',
                            text: 'Estado de terapias actualizados correctamente!'
                        })
                        this.$router.go(0)
                    }
                } catch (error) {
                    console.error('Erro:', error);
                }
            }
        },
        selectedTerapia(id) {
            const index = this.idsTerapias.indexOf(id);

            if (index !== -1) {

                this.idsTerapias.splice(index, 1);
            } else {

                this.idsTerapias.push(id);
            }

        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            console.log("llegamos ", this.currentPage)
        },
        cambiarPagina(pagina_actual) {
            // Actualizar currentPage con el nuevo número de página
            this.currentPage = pagina_actual;
            console.log("Nueva página actual:", this.currentPage);
            const establecimientoValue = this.isXima
              ? (this.consultarestablecimiento ? this.consultarestablecimiento.toString() : '')
              : this.idEstablecimiento;
            this.fetchConsultarTerapia(this.consultarterapia ? this.consultarterapia : '', this.currentPage, establecimientoValue, this.perPage);
            console.log("hey", pagina_actual)
        },
        async fetchEstablecimientos() {
            const query = `
                        query {
                            allEstablecimientos {
                                id
                                Descripcion
                                uniCodigo
                            }
                        }
                    `;
            try {
                const response = await axios.post(rutas.axios + 'api', { query });
                const lista = (response && response.data && response.data.data && response.data.data.allEstablecimientos)
                  ? response.data.data.allEstablecimientos
                  : [];
                this.establecimientos = lista.map(item => ({
                    value: item.id,
                    text: item.Descripcion,
                    uniCodigo: item.uniCodigo
                }));
                this.establecimientosList = this.establecimientos;
            } catch (error) {
                console.error('An error occurred while fetching the options:', error);
            }
        },

        async fetchTipoTerapias() {
            const query = `
                query obtenerTipoTerapia { allTipoterapias { id descripcion } }
            `;
            try {
                const response = await axios.post(rutas.axios + 'api', { query });
                this.tiposTerapia = (response && response.data && response.data.data && response.data.data.allTipoterapias)
                    ? response.data.data.allTipoterapias.map(item => ({ value: item.id, text: item.descripcion }))
                    : [];
            } catch (error) {
                console.error('An error occurred while fetching tipos de terapia:', error);
            }
        },

        // Intenta parsear JSON de forma segura. Devuelve objeto vacío si viene vacío o inválido
        convertTojson(jsonString) {
            return this.parseFlexibleJson(jsonString);
        },

        parseFlexibleJson(value) {
            if (!value) return {};
            if (typeof value === 'object') return value;
            try {
                return JSON.parse(value);
            } catch (error) {
                try {
                    const fixed = value.replace(/'/g, '"').replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');
                    return JSON.parse(fixed);
                } catch (err) {
                    console.warn('No se pudo parsear JSON flexible', value);
                    return {};
                }
            }
        },

        async fetchConsultarTerapia(search = '', pagina_actual = this.currentPageModificado, establecimiento = '', pageSize = this.perPage, estado = '1') {

            const establecimientoFiltro = establecimiento !== '' && establecimiento !== null && establecimiento !== undefined
              ? establecimiento
              : (this.isXima ? '' : this.idEstablecimiento);

            const query = `
            query GetAllTerapias($search: String, $establecimiento: String, $page: Int, $pageSize: Int, $estado : String) {
                allTerapias(search: $search, establecimiento: $establecimiento, page: $page, pageSize: $pageSize, estado : $estado) {
                    total
                    status
                    message
                    terapias {
                        id
                        token
                        nombre
                        tipoTerapia { id descripcion }
                        establecimiento
                        usuarioCreador {
                            id
                            username
                        }
                        codigo
                        estado
                        precio
                        precioJson
                        estadoJson
                    }
                    pageInfo {
                        currentPage
                        totalPages
                        hasNextPage
                        hasPreviousPage
                    }
                }
            }

            `;
            const var_consulta = {
                search: search,
                page: pagina_actual,
                pageSize: pageSize,
                establecimiento: establecimientoFiltro ? establecimientoFiltro.toString() : '',
                estado: estado
            }
            try {
                const response = await axios.post(rutas.axios + 'api', { query, variables: var_consulta });
                console.log(response)

                if (response.status === 200) {
                    if (response.data.data.allTerapias.status === 'Success') {
                        if (response.data.data.allTerapias.terapias) {
                            this.items = response.data.data.allTerapias.terapias.map(item => {
                                const estIds = (item.establecimiento || '').split(',').map(e => e.trim()).filter(Boolean);
                                const establecimientosConEstado = (this.establecimientosList && this.establecimientosList.length)
                                  ? this.establecimientosList.map(est => ({
                                        id: est.value ? String(est.value) : '',
                                        nombre: est.text,
                                        activo: estIds.includes(String(est.value)),
                                    }))
                                  : estIds.map(id => ({ id, nombre: id, activo: true }));

                                return {
                                    idTerapia: item.id,
                                    estado: item.estado,
                                    tokenTerapia: item.token,
                                    establecimientos: establecimientosConEstado,
                                    nombre: item.nombre,
                                    tipoTerapia: item.tipoTerapia ? item.tipoTerapia.descripcion : '',
                                    tipoTerapiaId: item.tipoTerapia ? item.tipoTerapia.id : null,
                                    codigo: item.codigo,
                                    precio: item.precio ? item.precio : "No disponible",
                                    usuario: item.usuarioCreador ? item.usuarioCreador.username : "No disponible",
                                    // Parseo seguro: backend puede devolver cadenas vacías
                                    precioJson: this.convertTojson(item.precioJson),
                                    estadoJson: this.convertTojson(item.estadoJson)
                                };
                            });
                            console.log("yey", this.items);

                            this.totalRows = response.data.data.allTerapias.total;
                            this.currentPage = 1;
                            this.currentPageModificado = pagina_actual
                        } else {
                            console.log("No se encontraron terapias");
                            // Aquí podrías establecer un mensaje en la interfaz de usuario
                        }
                    } else {
                        console.log("Error en la respuesta del servidor");
                        // Manejo del error de respuesta del servidor
                    }
                }
            } catch (error) {
                console.error("Error fetching terapia:", error);
                // Aquí también podrías mostrar un mensaje de error en la interfaz de usuario
            }
        },
        buscarTerapia() {
            const establecimientoValue = this.isXima
              ? (this.consultarestablecimiento ? this.consultarestablecimiento.toString() : '')
              : this.idEstablecimiento;
            // Aplicar todos los filtros al presionar buscar
            this.appliedFiltroTipo = this.filtroTipoTerapia;
            this.fetchConsultarTerapia(this.consultarterapia ? this.consultarterapia : '', this.currentPage, establecimientoValue, 15, this.estado);

        },

        viewItem(tokenTerapia) {
            this.tokenSeleccionado = tokenTerapia;
            this.$bvModal.show('modal-ver-terapia');
        },
        cargarComponente() {
            // Cargar dinámicamente el componente cuando se muestra el modal
            import('./CrearEditarTerapia.vue').then(componente => {
                this.componenteDinamico = componente.default;
            }).catch(error => {
                console.error('Error al cargar el componente:', error);
            });

        }
        ,
        editItem(tokenTerapia) {
            this.tokenSeleccionado  = tokenTerapia
            this.$bvModal.show('modal-editar-terapia')
        },
        removeItemid(idTerapia) {
            const mesa = this.fetchRemoveTerapia(idTerapia);
        },
        async fetchRemoveTerapia(idTerapia) {

            this.$swal({
                title: 'Estas seguro de eliminar terapia?',
                text: "No seras capaz de revertir esto!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, Borrar esto!',
                cancelButtonText: 'No, cancelar!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    // Call the API or method to remove the item here
                    try {
                        const argTerp = {
                            id: idTerapia,
                        }
                        const response = await axios.post(rutas.axios + 'api', {
                            query: `mutation EliminarTerapia($id: String!) {
                                        removerTerapia(terapiaDatos: { id: $id }) {
                                            status
                                            message
                                        }
                                    }
                                        `,
                            variables: argTerp
                        });
                        if (response.status === 200) {
                            if (response.data.data.removerTerapia.status === 'success') {
                                if (response.status === 200) {
                                    this.$swal({
                                        title: 'Borrado!',
                                        text: 'Tu registro ha sido eliminado',
                                        icon: 'success',
                                        confirmButtonColor: '#3085d6'
                                    }).then((result) => {
                                        // This will only run when the user presses "OK" on the "Deleted!" modal
                                        if (result.isConfirmed) {
                                            this.$router.go(0);
                                        }
                                    });
                                }
                                this.$router.push({ name: 'consultar_cartera_terapia' }).catch(err => {
                                    if (err.name !== 'NavigationDuplicated') {
                                        console.error(err);
                                    }
                                });
                            } else {
                                this.$swal({
                                    title: 'Error',
                                    text: response.data.data.removerTerapia.message,
                                    icon: 'error',
                                    confirmButtonColor: '#089599',
                                })
                            }
                        }
                    } catch (err) {
                        console.log(err);
                        return 'Error al eliminar la terapia';
                    }
                } else {
                    // User clicked the cancel button
                    this.$swal({
                        title: 'Cancelado',
                        text: 'Your registro esta seguro :)',
                        icon: 'error',
                        confirmButtonColor: '#3085d6'
                    });
                }
            });
        },
        setToken() {
            const user = JSON.parse(localStorage.getItem('usuario'))
            this.login_user = user.username
            axios.defaults.headers.common.Authorization = `JWT ${user.token}`
        },
        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`
            this.infoModal.content = JSON.stringify(item, null, 2)
            this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },

        truncateTexto(texto, maxLength = 50) {
            if (!texto) return '';
            return texto.length > maxLength ? `${texto.slice(0, maxLength)}...` : texto;
        },
    },
}
</script>
